import getVideoId from "get-video-id"

export default {
  install: function(Vue, name = '$getVideoId') {
    Object.defineProperty(Vue.prototype, name, { value: getVideoId });
  }
}
